<h2 mat-dialog-title>Agent Details</h2>
<mat-dialog-content>
  <!-- Agent details will be shown here in the future -->
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
